export default __webpack_public_path__ + "static/ifeat_thumbnail-fcc8ce63a10de893c472da3f988d676d.png";